module.exports = __webpack_public_path__ + "img/userEquity4.5bcfdb13.png";